<template>
    <ui-modal
        :title="modalTitle"
        ref="modal"
        :small="true"
    >
        <div class="content-holder">
            <div>
                <template
                    v-if="isNotEmpty"
                >
                    <section
                        v-for="update in projectUpdates"
                        :key="update.id"
                        class="section entry"
                        :id="'update-'+update.id"
                    >
                        <div class="heading">
                            <h2 class="title">
                                {{ update.title }}

                                <span class="tag is-light" v-text="getUpdateTypeLabel(update)"></span>
                            </h2>

                            <div class="entry-controls">
                                <p class="subtitle">
                                    Posted by <strong>{{ update.user.name }}</strong> | Last updated at <strong>{{ moment(update.updated).format('LLLL') }}</strong>
                                </p>
                            </div>
                        </div>

                        <div v-html="update.description"></div>
                    </section>
                </template>
                <template v-else>
                    <div class="notification mt">
                        <p>{{ trans('app.project.update.none').titleCase() }}</p>
                    </div>
                </template>
            </div>
        </div>
        <footer slot="footer">
            <a
                class="button is-medium mrs"
                @click="closeModal"
            >{{ trans('app.cancel').titleCase() }}</a>
        </footer>
    </ui-modal>
</template>

<script>

export default {
    props: {
    },

    data () {
        return {
            projectUpdates: [],
        };
    },

    computed: {
        isNotEmpty () {
            return ! _.isEmpty(this.projectUpdates);
        },

        modalTitle () {
            return 'Updates List';
        },
    },

    listeners: {
        'project-updates-list-modal-open' (projectUpdates) {
            this.projectUpdates = _.clone(projectUpdates);
            this.showModal();
        },
    },

    methods: {
        openDetailsModal (update) {
            OSPEvent.$emit('open-project-update-details', update);
        },

        getUpdateTypeLabel (update) {
            if (update.related_type === 'project') {
                return 'Project';
            }
        },

        showModal () {
            this.$refs.modal.show();
        },

        closeModal () {
            this.$refs.modal.hide();
            this.projectUpdates = [];
        },
    },
};
</script>
